<template>
  <div class="list_best_request on3">
    <!--요금 낮은 순 일때 on2, 지원금 높은 순일때 on3-->
    <div class="list_hori_contents">
      <ul>
        <li><p>통신사</p></li>
        <li>
          <p>요금<span>(원)</span></p>
        </li>
        <li>
          <p>지원금<span>(원)</span></p>
        </li>
      </ul>
    </div>
    <div class="list_horizontal">
      <ul class="list_hori_ul">
        <li
          class="list_hori_li"
          v-for="(item, index) in bestList"
          :key="index"
          @click="moveList(index)"
        >
          <!-- <a :href="`#list_${index}`"> -->
          <div class="tag" :class="{ best: index === 0 }" v-if="index < 3">
            <p>{{ index + 1 }}등</p>
          </div>
          <div class="shop_prof">
            <div class="profile_image">
              <div class="thumb_image">
                <div class="thumb_image_inner">
                  <img
                    v-if="item.store.storeProfile"
                    :src="item.store.storeProfile"
                    alt=""
                  />
                  <img
                    v-else
                    :src="setShopProfileImg(item.store.storeName, item.storeId)"
                    alt=""
                  />
                  <img
                    v-if="item.store.cert === 1"
                    :src="
                      require('@/assets/front/images/v2/etc/icon_consent_m.png')
                    "
                    alt=""
                    class="consent"
                  />
                </div>
              </div>
            </div>
            <p>{{ item.store.storeName }}</p>
          </div>
          <ul>
            <li>
              <p>{{ item.telecom }}</p>
            </li>
            <li>
              <p>{{ item.monthPrice | comma }}</p>
            </li>
            <li>
              <p>
                {{
                  (item.cashSupport +
                    item.giftCardSupport +
                    item.giftItemSupport)
                    | comma
                }}
              </p>
            </li>
          </ul>
          <!-- </a> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    bestList: Array,
  },
  components: {},
  data() {
    return {};
  },
  async created() {},
  computed: {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  methods: {
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '20');

      return path;
    },
    moveList(index) {
      // alert('1 = ' + index);
      this.$emit('moveList', index);
    },
  },
};
</script>
